<template>
    <UBadge :color="color" :variant="variant" :size="size" class="capitalize">
        {{ displayRole }}
    </UBadge>
</template>

<script setup lang="ts">
interface Props {
    role: 'parent' | 'child' | string
    color?: string
    variant?: string
    size?: string
}

const props = withDefaults(defineProps<Props>(), {
    color: 'gray',
    variant: 'subtle',
    size: 'sm'
})

const displayRole = computed(() => {
    return props.role === 'child' ? 'Dependent' : props.role
})
</script>
